import { render, staticRenderFns } from "./LayerTableAttribute.vue?vue&type=template&id=1062aa25"
import script from "./LayerTableAttribute.vue?vue&type=script&lang=js"
export * from "./LayerTableAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports